import { useEffect, useState } from "react";
import {
  Pagination,
  PaginationItem,
  PaginationFirst,
  PaginationPrev,
  PaginationNext,
  PaginationLast,
  PaginationEllipsis,
  getPaginationRange,
} from "../../components/ui/pagination";
import CustomerCard from "../../components/employee/CustomerCard";
import CustomerSearch from "../../components/employee/CustomerSearch";
import { buildSearchRequest } from "../../rest/buildSearchRequest";
import { SearchParams, SearchResponse, SearchResult } from "../../rest/defs";
import RestrictedAccess from "../../components/RestrictedAccess";
import { CurrentSessionData } from "../../hooks/userSession";
import { authFetch } from "../../rest/authFetch";

const CustomerList = ({
  currentSession,
}: {
  currentSession: CurrentSessionData;
}) => {
  const [searchParams, setSearchParams] = useState<SearchParams>({
    phone: "",
    name: "",
    page: "1",
  });

  const [searchResult, setSearchResult] = useState<SearchResult>({
    total_customers: 0,
    total_pages: 1,
    customers: [],
  });

  const updatePage = (page: string) => {
    setSearchParams({ ...searchParams, page: page });
  };

  const shiftPage = (step: number) => {
    let nextPage = Number(searchParams.page) + step;
    nextPage = nextPage > searchResult.total_pages ? 1 : nextPage;
    nextPage = nextPage < 1 ? searchResult.total_pages : nextPage;
    updatePage(String(nextPage));
  };

  const executeSearch = (phone: string, name: string) => {
    setSearchParams({ name: name, phone: phone, page: "1" });
  };

  useEffect(() => {
    const requestParams = buildSearchRequest(searchParams);
    const url = `${process.env.REACT_APP_API_BASE_URL}/customer/search/${requestParams}`;
    authFetch(url)
      .then((response) => response.json())
      .then((result: SearchResponse) => {
        if (result?.success) {
          const fixedCustomers = result.data.customers.map((item) => {
            return { ...item, age_segment: String(item.age_segment) };
          });
          const fixedData: SearchResult = {
            ...result.data,
            customers: fixedCustomers,
          };
          setSearchResult(fixedData);
        }
      })
      .catch(console.error);
  }, [searchParams]);

  return (
    <RestrictedAccess currentSession={currentSession}>
      <div className="space-y-4">
        <h5 className="text-lg font-semibold">Búsqueda de Clientes</h5>

        <CustomerSearch onChange={executeSearch} />

        <div className="space-y-2">
          <small>
            <strong>
              {searchResult.total_customers} cliente
              {searchResult.total_customers > 1 ? "s" : ""}
            </strong>
          </small>
          <Pagination>
            <PaginationFirst onClick={() => updatePage("1")} />
            <PaginationPrev onClick={() => shiftPage(-1)} />
            {getPaginationRange(
              Number(searchParams.page),
              searchResult.total_pages
            ).map((item, index) =>
              item === "ellipsis" ? (
                <PaginationEllipsis key={`ellipsis-${index}`} />
              ) : (
                <PaginationItem
                  key={item}
                  onClick={() => updatePage(String(item))}
                  active={String(item) === searchParams.page}
                >
                  {item}
                </PaginationItem>
              )
            )}
            <PaginationNext onClick={() => shiftPage(1)} />
            <PaginationLast
              onClick={() => updatePage(String(searchResult.total_pages))}
            />
          </Pagination>
        </div>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {searchResult.customers.map((item) => {
            return <CustomerCard item={item} key={item.id} />;
          })}
        </div>
      </div>
    </RestrictedAccess>
  );
};

export default CustomerList;
